import { Component, OnInit } from '@angular/core';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogQrAssetDetailsComponent } from '../dialog-qr-asset-details/dialog-qr-asset-details.component';
import { DialogPhotosVideosComponent } from '../dialog-photos-videos/dialog-photos-videos.component';

@Component({
  selector: 'app-asset-transfer-list',
  templateUrl: './asset-transfer-list.component.html',
  styleUrls: ['./asset-transfer-list.component.scss']
})
export class AssetTransferListComponent implements OnInit {


  ngOnInit(): void {

  }
  constructor(private spinner: NgxSpinnerService, public dialog: NgDialogAnimationService,) { }

  pending() {
    const dialogRef = this.dialog.open(DialogQrAssetDetailsComponent,
      {
        data: 'vijay',
        direction: 'ltr',
        height: '100%',
        width: '40%',
        position: { right: '0px', top: '0px' },
        animation: { to: 'left' }
      }
    )
  }

  photo() {
    const dialogRef = this.dialog.open(DialogPhotosVideosComponent, {
      data: 'kumar',
      direction: 'ltr',
      height: '100%',
      width: '40%',
      position: { right: '0px', top: '0px' },
      animation: { to: 'left' }
    }
    )
  }

}
